import { mergeFragments } from "../../mergeFragments";
import base from "./base";
import siteBuilder from "./siteBuilder";
import onboarding from "./onboarding";
import media from "./media";
import layoutNav from "./layoutNav";
import billing from "./billing";
import modals from "./modals";
import strays from "./strays";
import punch from "./punch";
import stripeTransactions from "./stripeTransactions";
import gatewayWallet from "./gatewayWallet";
import bookingServices from "./bookingServices";
import pricingFix from "./pricingFix";
import taxReceipts from "./taxReceipts";
import notifications from "./notifications";
import reschedule from "./reschedule";
import clientBookingPolicy from "./clientBookingPolicy";
import siteRepeaters from "./siteRepeaters";
import siteContentRows from "./siteContentRows";
import promos from "./promos";
import saveValidation from "./saveValidation";
import validationSweep from "./validationSweep";
import consultTelehealth from "./consultTelehealth";
import catalogueEditing from "./catalogueEditing";
import palette from "./palette";
import quizReviews from "./quizReviews";
import openHours from "./openHours";
import affiliate from "./affiliate";
import reviews from "./reviews";
import publicProfile from "./publicProfile";
import entitlements from "./entitlements";
import customDomain from "./customDomain";
import pathways from "./pathways";
import pathwaysWorkspace from "./pathwaysWorkspace";
import pathwaysMaterials from "./pathwaysMaterials";
import platformOffers from "./platformOffers";
import insights from "./insights";
import professionalMembership from "./professionalMembership";

export default mergeFragments([base, siteBuilder, onboarding, media, layoutNav, billing, modals, strays, punch, stripeTransactions, gatewayWallet, bookingServices, pricingFix, taxReceipts, notifications, reschedule, clientBookingPolicy, siteRepeaters, siteContentRows, promos, saveValidation, validationSweep, consultTelehealth, catalogueEditing, palette, quizReviews, openHours, affiliate, reviews, publicProfile, entitlements, customDomain, pathways, pathwaysWorkspace, pathwaysMaterials, platformOffers, insights, professionalMembership]);
